
import { store } from '../state';
import { CONFIG_COMMAND_SYNTAX, CONFIG_STATE, State, TwitchChannelTag, TwitchPaginatedDataResult } from '../types';
import { defineComponent } from 'vue';
import { twitch } from '@/twitch-instance';
import { convertTwitchTagsToTagData } from '@/utils';

export default defineComponent({
  data () {
    return {
      state: store.state as State,
      commandSyntax: '' as string,
      importedTags: 0,
      currentlyImportingTags: false
    }
  },
  mounted () {
    this.commandSyntax = CONFIG_STATE[CONFIG_COMMAND_SYNTAX];
  },
  computed: {
    isLoggedIn: () => {
      return store.state.loggedIn;
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    save () {
      localStorage.setItem(CONFIG_COMMAND_SYNTAX, this.commandSyntax);
      CONFIG_STATE[CONFIG_COMMAND_SYNTAX] = this.commandSyntax;

      this.$emit('save');
    },
    async importTwitchTags () {
      this.currentlyImportingTags = true;

      let lastCursor = '';
      let result: TwitchPaginatedDataResult<TwitchChannelTag>;

      do {
        result = await twitch.listFirstTags(lastCursor);

        if (!result) {
          break;
        }

        console.info({ result });

        if (result.data.length) {
          const importableTags = convertTwitchTagsToTagData(result.data);

          const newTags = store.importUnknownTags(importableTags);

          if (newTags === 0) {
            break;
          }
        }

        lastCursor = result.pagination.cursor;
      } while (result.data.length !== 0);
    }
  }
});
